export default __webpack_public_path__ + "static/media/lazard.b466c3bd.svg";